// src/components/ui/ConfirmModal.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../hooks';
import Btn from './Btn';
import PajNtaubBand from './PajNtaubBand';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  confirmVariant,
  loading,
}) => {
  const { onBackdrop } = useModal(isOpen, onClose);
  const { t } = useTranslation();
  const resolvedConfirmLabel = confirmLabel || t('confirmModal.defaultConfirm');

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/50 backdrop-blur-sm flex items-end sm:items-center justify-center sm:p-4 animate-fade-in"
      onClick={onBackdrop}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className="bg-white dark:bg-gray-900 rounded-t-2xl sm:rounded-xl shadow-2xl w-full sm:max-w-sm animate-slide-up overflow-hidden"
        style={{ overscrollBehavior: 'contain' }}
      >
        <PajNtaubBand height={4} />
        <div className="p-4 sm:p-6">
          <h3 className="text-base font-semibold mb-2 dark:text-gray-100">{title}</h3>
          <p className="text-gray-500 dark:text-gray-400 text-sm mb-4 sm:mb-6">{message}</p>
          <div className="flex gap-3">
            <Btn v="ghost" onClick={onClose} className="flex-1">
              {t('confirmModal.cancelBtn')}
            </Btn>
            <Btn
              onClick={onConfirm}
              v={confirmVariant === 'danger' ? 'ghost' : 'primary'}
              className={`flex-1${confirmVariant === 'danger' ? ' bg-red-600 hover:bg-red-700 text-white' : ''}`}
              loading={loading}
            >
              {resolvedConfirmLabel}
            </Btn>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
